<template>
  <div class="home">
    <el-container>
      <el-header>
        <v-head
          :active="3"
          :bannerData="bannerData"
          :isBanner="true"
          :color="'black'"
          indicator="none"
        ></v-head>
        <szhimg  :bannerData="bannerData"
          :isBanner="true"
          :color="'black'"
          indicator="none" />
      </el-header>
      <el-main style="position: relative;height: 100%;">
        <div class="content">
          <!-- 四大能力 -->
          <div class="ability">
            <div class="wrapper">
              <div class="title">四大能力</div>
              <div class="bg-scheme">FOUR MAJOR CAPABILITIES</div>
              <div class="list">
                <div class="item" v-for="item in abilityList" :key="item.name">
                    <div class="img"><img class="listimgs" :src="item.img" alt=""></div>
                    <div class="name">{{item.name}}</div>
                    <span class="desc">{{item.desc}}</span>
                    <div class="desc1">{{item.desc1}}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 五大服务支撑 -->
          <div class="service" style="margin-top: 60px;">
            <div class="wrapper">
              <div class="title">五大服务支撑</div>
              <div class="bg-scheme">FIVE MAJOR SERVICE SUPPORTS</div>
              <div class="list">
                <div class="item" v-for="item in serviceList" :key="item.name">
                    <div class="img"><img class="serviceimg" :src="item.img" alt=""></div>
                    <div class="name">{{item.name}}</div>
                    <div class="desc">{{item.desc}}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 智慧平台运营 -->
          <div class="platform" style="margin-top: 60px;">
            <div class="wrapper">
              <div class="title">智慧平台运营</div>
              <div class="bg-scheme">INTELLIGENT PLATFORM OPERATION</div>
              <div class="list">
                <div class="item"  v-for="(item, index) in platformList" :key="item.name" @click="clickNav(index)">
                    <div class="box" :class="classObj(index)">
                        <div class="img"><img class="boximg1" :src="platFormActive == index ? item.action_icon : item.icon" alt=""></div>
                        <div class="nav" :class="platFormActive == index ? 'activeNav' : ''">{{item.name}}</div>
                    </div>
                </div>
              </div>
              <!-- 智慧园区平台 -->
              <div v-for="(item, index) in platFormDetails" :key="item.bottomTittle">
                <div class="tab" v-show="platFormActive == index" >
                    <div class="carousel"  :style="platFormActive === index ? { marginTop: item.hig } : {} "  >
                        <div class="toleft" v-show="item.topImg.length > 1" @click="headAtiveClick(index, 'prev')"></div>
                        <div class="pic" :style="platFormActive === 1 ? { marginBottom: '100px' } : {}"  ><img :src="platFormHeadCurrent"  alt=""></div>
                        <div class="toright" v-show="item.topImg.length > 1" @click="headAtiveClick(index, 'next')"></div>
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="c_title">{{item.bottomTittle}}</div>
                            <div class="en">{{item.bottomEn}}</div>
                            <div class="desc">{{item.bottomDesc}}</div>
                            <div class="btn">
                                <div class="toleft" @click="bottomAtiveClick(index, 'prev')"></div>
                                <div class="toright" @click="bottomAtiveClick(index, 'next')"></div>
                            </div>
                        </div>
                        <div style="display: flex;">
         
                          <div class="right scrollable" :ref="'rightScroll' + index">
                            <div class="scroll-inner" style="display: flex; gap: 12px;">
                              <!-- <div class="left-gap" style="width: 300px; flex-shrink: 0; pointer-events: none;"></div> -->
                              <div v-for="(type, cardIdx) in item.bottomImg" :key="type.title" class="label" :class="bottom_ative == cardIdx ? 'bottom_label_active' : ''" :ref="bottom_ative == cardIdx ? 'activeCard-' + index + '-' + cardIdx : null">
                                <div class="bg"><img :src="type.imgs" alt=""></div>
                                <div class="l_img"><img :src="type.imgs" alt=""></div>
                                <div class="l_title">{{type.title}}</div>
                                <div class="l_desc">{{type.desc}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
              </div>
              <img src="../../public/img/intelligentize/pic_szh_zhptyy_bg.png" class="tab_bg" alt="">
            </div>
          </div>

          <!--  -->
          <div class="digital">
            <div class="wrapper">
              <div class="title">数字化转型服务</div>
              <div class="bg-scheme">DIGITAL TRANSFORMATION SERVICES</div>
              <div class="box">
                <div class="left">
                    <span class="text1">诊断</span>
                    <span class="text2">服务</span>
                    <div class="img"><img class="yuan1" src="../../public/img/intelligentize/pic_azh_szhzx_zdfw.png" alt=""></div>
                </div>
                <div class="right">
                    <span class="text1">改造</span>
                    <span class="text2">服务</span>
                    <div class="img"><img class="yuan1"  src="../../public/img/intelligentize/pic_azh_szhzx_gzfw.png" alt=""></div>
                </div>
              </div>
            </div>
          </div>

          <!-- 成功案例 -->
          <div class="case">
            <div class="wrapper">
              <div class="title">成功案例</div>
              <div class="bg-scheme">SUCCESS CASE</div>
              <div class="box">
                <div class="img"><img class="boxsimg" :src="currentCaseImg" alt=""></div>
                
                <div class="framework">
                    <div class="wrap">
                        <div class="filter"></div>
                        <div class="left">
                            <div class="item" v-for="(item, index) in caseDetailList" :key="item.name">
                                <template v-if="index == currentCase">
                                    <div class="i_name">{{item.name}}</div>
                                    <div class="i_desc">{{item.desc}}</div>
                                    <div class="ul">
                                        <div class="label" v-for="(label, i) in item.table" :key="label.name">
                                            <div class="l_img"><img class="listimg" :src="label.icon" alt=""></div>
                                            <div class="l_name">{{label.name}}</div>
                                        </div>
                                    </div>
                                    <div class="scene">
                                        <div class="scene_l">
                                            <div class="name">应用场景</div>
                                            <div class="en">Application scenarios</div>
                                        </div>
                                        <div class="scene_r">
                                            <div class="pic" v-for="(img, inx) in item.scenList" :key="img.name" @click="showPic(index, inx)">
                                                <div class="img"><img class="listimg" :src="img.img" alt=""></div>
                                                <div class="name">{{img.name}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="right">
                            <div class="list">
                                <div class="item" :class="currentCase == index ? 'currentBg' : ''" v-for="(item, index) in caseMenuList" :key="item.name" @click="caseMenuClick(index)">
                                    <div class="icon"><img :src="currentCase == index ? item.activeIcon : item.icon" alt=""></div>
                                    <div class="msg">
                                        <div class="m_name" :class="currentCase == index ? 'currentName' : ''">{{item.name}}</div>
                                        <div class="m_en" :class="currentCase == index ? 'currentEn' : ''">{{item.en}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footIcon"><img class="footimg" src="../../public/img/intelligentize/icon_szh_cgal_yycj@2x.png" alt=""></div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <el-footer style="background:#f4f6f9;">
        <v-footer></v-footer>
      </el-footer>
    </el-container>
    <plan-dialog
      :isShow="isShow"
      v-if="isShow"
      @closeTop="closeTop"
    ></plan-dialog>
    <div class="mask" v-if="showBigPic">
        <div class="dialog">
            <div class="head">
                <div class="left">
                    <div class="icon"><img src="../../public/img/intelligentize/icon_szh_cgal_tctitle.png" alt=""></div>
                    <div class="name">{{bigImg[bigImgIndex].name}}（{{bigImgIndex+1}}/4）</div>
                </div>
                <div class="close" @click="showBigPic = false"><img src="../../public/img/intelligentize/icon_szh_cgal_tcclose.png" alt=""></div>
            </div>
            <div class="bigImg"><img :src="bigImg[bigImgIndex].img" alt=""></div>
            <div class="btn">
                <div class="pre" @click="bigImgClick(bigImgIndex, 'prev')"></div>
                <div class="next" @click="bigImgClick(bigImgIndex, 'next')"></div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import vHead from "../components/head.vue";
import vFooter from "../components/footer2.vue";
import planDialog from "@components/planDialog.vue";
import szhimg from "./szhimg.vue";
export default {
  name: "digitalIntelligence",
  metaInfo: {
    title: "数智化",
    meta: [
      {
        name: "keyWords",
        content: "物联网，网关，自动化，软硬件开发，车联网，监控，智慧码头",
      },
    ],
  },
  components: {
    vHead,
    vFooter,
    planDialog,
    szhimg
  },
  data() {
    return {
      isShow: false,
      showBigPic: false,
      bannerData: [
        {
          title: "数据驱动高端创新智能构建生态协同",
          titleWrap: true,
          content:
            "提供各种专业、高效的工业数智化场景智能解决方案，通过数智化控制、大数据分析、人工智能等技术手段，赋能工业生产，擘画更高质量、更高效率、更低成本的愿景蓝图。",
          button: "获取专属方案",
          banner: "digital_bg",
        },
      ],
      abilityList: [
        {
            name: '软件开发能力',
            desc: 'SOFTWARE DEVELOPMENT',
            desc1:'ABILITY',
            img: require('../../public/img/intelligentize/icon_szh_sdnl_rjkf.png')
        },
        {
            name: '硬件开发设计能力',
            desc: 'HARDWARE DEVELOPMENTAND',
            desc1:'DESIGN CAPABILITIES',

            img: require('../../public/img/intelligentize/icon_szh_sdnl_yjkf.png')
        },
        {
            name: '平台运营能力',
            desc: 'PLATFORM OPERATION CAPABILITY',
            desc1:'CAPABILITY',

            img: require('../../public/img/intelligentize/icon_szh_sdnl_ptyy.png')
        },
        {
            name: '方案集成能力',
            desc: 'SOLUTION INTEGRATION CAPABILITY',
            desc1: 'CAPABILITY',
            img: require('../../public/img/intelligentize/icon_szh_sdnl_fajc.png')
        }
      ],
      serviceList: [
       {
        name: '私有化部署',
        desc: '私有化部署，内网访问严格的权限监控。',
        img: require('../../public/img/intelligentize/icon_szh_wdfw_syhbs.png')
       },
       {
        name: '远程调试测试',
        desc: '可对设备进行远程在线调试，降低人员成本，提高调试效率。',
        img: require('../../public/img/intelligentize/icon_szh_wdfw_ycts.png')
       },
       {
        name: '数据孤岛打通',
        desc: '搭建企业的数据湖，打通企业内、企业间的数据孤岛。',
        img: require('../../public/img/intelligentize/icon_szh_wdfw_sjgd.png')
       },
       {
        name: '数据可视化',
        desc: '让企业的管理和执行透明化、简单化、可视化以及痕迹化。',
        img: require('../../public/img/intelligentize/icon_szh_wdfw_sjksh.png')
       },
       {
        name: '全天候支撑',
        desc: '在产品、机器和设备的整个生命周期内提供快速而高效的支持。',
        img: require('../../public/img/intelligentize/icon_szh_wdfw_qthzc.png')
       },
      ],
      platformList: [
        {
            name: '智慧园区平台',
            icon: require('../../public/img/intelligentize/icon_szh_zhptyy_zhyq_nor.png'),
            action_icon: require('../../public/img/intelligentize/icon_szh_zhptyy_zhyq_pre.png'),
        },
        {
            name: '智慧能源平台',
            icon: require('../../public/img/intelligentize/icon_szh_zhptyy_zhny_nor.png'),
            action_icon: require('../../public/img/intelligentize/icon_szh_zhptyy_zhny_pre.png'),
        },
        {
            name: '智慧港口平台',
            icon: require('../../public/img/intelligentize/icon_szh_zhptyy_zhgk_nor.png'),
            action_icon: require('../../public/img/intelligentize/icon_szh_zhptyy_zhgk_pre.png'),
        },
        {
            name: '智慧矿山平台',
            icon: require('../../public/img/intelligentize/icon_szh_zhptyy_zhks_nor.png'),
            action_icon: require('../../public/img/intelligentize/icon_szh_zhptyy_zhks_pre.png'),
        },
        {
            name: '智慧工厂平台',
            icon: require('../../public/img/intelligentize/icon_szh_zhptyy_zhgc_nor.png'),
            action_icon: require('../../public/img/intelligentize/icon_szh_zhptyy_zhgc_pre.png'),
        },
      ],
      platFormActive: 0,
      head_ative: 0,
      bottom_ative: 0,
      offset: 0,
      cardWidth: 322,
      cardGap: 12,
      visibleCount: 4,
      platFormDetails: [
        {
            hig : '-130px',
            topImg: [
                require('../../public/img/intelligentize/pic_szh_zhptyy_yq_lb.png')
            ],
            bottomTittle: '0碳智慧园区管理平台',
            bottomEn: 'Zero-carbon Smart park management platform',
            bottomDesc: '智慧园区平台是园区数字化与智能化建设的核心底座，亦是企业及行业迈向数字化的关键枢纽。基于物联网、云计算、AI大模型、大数据及可视化技术将重塑园区中的人机、物、事的联接，通过数字孪生的方式对园区各类管理对象进行建模和孪生体化重构园区的管理方式，将ICT能力、园区业务和生产办公全面智慧化。',
            bottomImg: [
                {
                    img: require('../../public/img/intelligentize/wulian.png'),
                    imgs: require('../../public/img/intelligentize/bgimg1.png'),
                    title: '物联管理',
                    desc: '基于云百物联网优势及自研网关及DTU的能力助力园区构建起包括：生产设备、安消智能化终端 、重要资产等设备的全域物联网。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_yq_aidmx.png'),
                    imgs: require('../../public/img/intelligentize/bgimg2.png'),

                    title: 'AI大模型',
                    desc: '基于Deepseek、Qwen等大模型的本地化部署与应用，可通过构建园区专属知识库实现运营数据的挖掘、智能的预测预警及决策建议，并为园区构建专属智能体Agent、实现自动工作流，奠定坚实基础。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_yq_stgl.png'),
                    imgs: require('../../public/img/intelligentize/bgimg3.png'),

                    title: '双碳管理',
                    desc: '基于园区用能数据，与碳中和认证相关标准智慧园区平台具备：碳排查、碳规划、碳管理、碳优化及碳交易管理功能，可自动生成符合ISO14064标准的碳排放报告，为园区的碳中和认证提供降碳策略及数据依据。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_yq_szls.png'),
                    imgs: require('../../public/img/intelligentize/bgimg4.png'),

                    title: '数字孪生',
                    desc: '基于Unity与UE5与3D建模技术，可实现园区的数字孪生化，将园区的生产及重要的设备与资产数字化，将其运行状态、空间位置映射到虚拟空间，园区态势直观展示到决策层眼前。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_yq_dsj.png'),
                    imgs: require('../../public/img/intelligentize/bgimg5.png'),

                    title: '大数据可视化',
                    desc: '基于智慧园区平台集成能力将园区内的信息化系统及各类在线设备的运行状态及运行数据采集同步到智慧园区数据中台，利用BI数据分析工具，将园区数据通过动态图表的方式展示出来，形成园区的数据驾驶舱。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_yq_dkyy.png'),
                    imgs: require('../../public/img/intelligentize/bgimg6.png'),

                    title: '低空应用',
                    desc: '基于通用及行业无人机，结合数字李生及高精度定位技术，智慧园区管理平台可实现无人机的自动化巡逻巡检及轻量级的物资配送利用其多光谱的视觉与快速到达能力，可有效的提高巡逻巡检的频次及准确度，提高轻量级物资的配送效率。'
                },
            ]
        },
        {
            hig : '0',
            topImg: [
                require('../../public/img/intelligentize/pic_szh_zhptyy_ny_lb1@2x.png'),
                require('../../public/img/intelligentize/pic_szh_zhptyy_ny_lb2@2x.png'),
                require('../../public/img/intelligentize/pic_szh_zhptyy_ny_lb3@2x.png'),
                require('../../public/img/intelligentize/pic_szh_zhptyy_ny_lb4@2x.png'),
            ],
            bottomTittle: '能源综合管理平台',
            bottomEn: 'Energy Comprehensive Management Platform',
            bottomDesc: '能源综合管理平台采用自动化、信息化技术和集中管理模式，对生产、输配和消耗环节实行集中扁平化的动态监控和数据化管理，监测各类能源的消耗情况，通过数据分析、挖掘和趋势分析，帮助用户针对各种能源需求及用能情况、能源质量、产品能源单耗、各工序能耗等的能源利用情况，为加强能源管理，提高能源利用效率、挖掘节能潜力、节能评估提供基础数据的支持。',
            bottomImg: [
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_ny_dnhb.png'),
                    imgs: require('../../public/img/intelligentize/bgimg2-1.png'),

                    title: '多能互补与动态优化',
                    desc: '综合电力、热能、冷能、燃气、水资源等多种能源形态，依据负荷预测模型与混合整数规划算法执行跨域调度，并通过大数据分析达成能源供需平衡及跨系统调度的优化，构建多时间尺度的优化策略。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_ny_qkl.png'),
                    imgs: require('../../public/img/intelligentize/bgimg2-2.png'),

                    title: '区块链云计算碳交易',
                    desc: '对能源生产、传输至消费各环节的碳排放数据进行追踪，构建全面覆盖能源生产、输送、分配及消费全过程的碳计量模型。该模型整合监测-报告-核查（MRV）体系，以实现与碳配额市场的无缝对接，并利用智能合约技术自动完成碳资产的交割。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_ny_ycx.png'),
                    imgs: require('../../public/img/intelligentize/bgimg2-3.png'),

                    title: '预测性维护与故障预警',
                    desc: '基于设备运行数据（如振动、温度）建立健康模型，提前识别变压器、光伏逆变器等关键设备潜在故障，减少非计划停机，并运用健康模型数据计算分析设备使用寿命，实现主要输变电设施维护周期延长。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_ny_fbs.png'),
                    imgs: require('../../public/img/intelligentize/bgimg2-4.png'),

                    title: '分布式能源储能管理电网优化',
                    desc: '联动用户侧储能和分布式能源（如屋顶光伏），构建分布式能源资源聚合优化模型动态调整用电策略以响应电网价格信号或负荷波动，降低用电成本。'
                },
                
            ]
        },
        {
            hig : '-90px',
            topImg: [
                require('../../public/img/intelligentize/pic_szh_zhptyy_gk_lb1@2x.png')
            ],
            bottomTittle: '智慧港口管理系统',
            bottomEn: 'Smart Port Management System',
            bottomDesc: '散货智慧港口以数字孪生技术为核心，构建虚实映射的虚拟港口模型，整合AI监控、无人机巡检与智慧仓储系统，实现全流程智能化管理。数字孪生通过实时数据采集与仿真优化资源配置，精准调度码头设施及装卸机械，减少拥堵并提升吞吐效率。智慧仓储依托物联网和RFID技术，实现货物全生命周期自动化追踪与库存管理。AI监控系统则结合深度学习算法，对港口安防、消防及设备运行进行实时预警与远程操控。',
            bottomImg: [
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_gk_zcdd.png'),
                    imgs: require('../../public/img/intelligentize/bgimg3-1.png'),

                    title: '装车调度',
                    desc: '根据仓位装载和排队情况自动分配仓位，充分利用空闲仓位，让设备得到充分的利用，帮助港口提升装车效率的同时提高港口码头吞吐量。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_gk_tldd.png'),
                    imgs: require('../../public/img/intelligentize/bgimg3-2.png'),

                    title: '混料调度',
                    desc: '根据客户所需配料成份、下料量自动分配调度仓号，减少人工干预，从而减少由人工失误产生的拿错单、卸错量、卸错料等问题的发生。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_gk_qyjk.png'),
                    imgs: require('../../public/img/intelligentize/bgimg3-3.png'),

                    title: '全域监控',
                    desc: '实时监控港口的安全状态，对港口内外的安全隐患进行预警和处理。同时，通过智能化安全管理系统对港口的安全设施进行管理和维护，提高港口的安全性和可靠性。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_gk_aizn.png'),
                    imgs: require('../../public/img/intelligentize/bgimg3-4.png'),

                    title: 'AI智能识别',
                    desc: '通过智能安防识别设备配合边缘计算，可对工作环境中的人员违规行为、险情等进行识别。如：安全帽佩戴识别、明火检测、工作服识别、离岗睡岗检测、危险区域入侵检测、反光衣识别等。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_gk_szls.png'),
                    imgs: require('../../public/img/intelligentize/bgimg3-5.png'),

                    title: '数字孪生',
                    desc: '具备地理信息系统(GIS)+三维的高精度匹配、全景融合、全要素互联等特点，实现了对船舶计划、装卸船进度、设备运行状态、料堆状态、堆取料作业、自动化作业等流程作业状态的全过程仿真模拟。'
                },
            ]
        },
        {
            hig : '-80px',

            topImg: [
                require('../../public/img/intelligentize/pic_szh_zhptyy_ks_lb1@2x.png'),
                require('../../public/img/intelligentize/pic_szh_zhptyy_ks_lb2@2x.jpg'),
            ],
            bottomTittle: '露天智慧矿山系统',
            bottomEn: 'Open-pit smart mine system',
            bottomDesc: '露天智慧矿山系统，作为一项集成化的管理控制平台，其构建基础依托于矿山数据的数字化、生产过程的实时监测以及管理活动的信息化。该系统融合了物联网、大数据、人工智能等新一代信息技术。该系统的显著优势在于能够降低人工成本、提高资源利用率以及提升安全生产水平。',
            bottomImg: [
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_ks_bpwy.png'),
                    imgs: require('../../public/img/intelligentize/bgimg4-1.png'),

                    title: '矿山边坡位移监测预警系统',
                    desc: '依托GNSS高精度定位、多源传感器网络及AI算法，实时监测边坡位移、形变及地质参数。系统采用RTK技术实现毫米级定位精度，结合测斜仪、渗压计等设备构建立体监测网络，通过边缘计算与云端平台对数据进行动态分析，运用灰预测模型及动态阈值算法生成四级(红橙黄蓝)智能预警，可提前数小时至数天识别滑坡风险。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_ks_zhyq.png'),
                    imgs: require('../../public/img/intelligentize/bgimg4-2.png'),
                    title: '矿山智慧园区',
                    desc: '以5G、工业物联网及边缘计算为核心，集成视频监控(支持4K智能分析)、人员定位(UWB精度±30cm)、环境监测(粉尘、温湿度、有害气体)、数据IDC中心等模块，通过统一平台实现数据融合与设备联动。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_yq_dkyy (1).png'),
                    imgs: require('../../public/img/intelligentize/bgimg4-3.png'),
                    title: '矿山无人机系统',
                    desc: '集成激光雷达、高光谱相机与RTK定位模块(水平精度±1cm)，实现矿区地形测绘(分辨率5cm)、边坡形变监测及非法盗采巡查。搭载多光谱传感器可识别尾矿渗漏(检测精度0.1ppm)，AI算法实时分析地表裂缝扩展趋势，通过5G专网回传数据至数字孪生平台生成三维风险热力图。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_ks_xnfz.png'),
                    imgs: require('../../public/img/intelligentize/bgimg4-4.png'),
                    title: '矿山虚拟仿真安全培训',
                    desc: '针对常见矿山事故的类型和薄弱地点、 薄弱人员，以虚拟现实方式打造矿山岗位及安全培训方案 ， 将安全理念直接融合到安全生产过程中 ， 全面提高员工杜绝事故和处理事故的能力！'
                },
            ]
        },
        {
            hig : '-70px',
            topImg: [
                require('../../public/img/intelligentize/pic_szh_zhptyy_gc_lb1@2x.png'),
                require('../../public/img/intelligentize/pic_szh_zhptyy_gc_lb2@2x.png'),
                require('../../public/img/intelligentize/pic_szh_zhptyy_gc_lb3@2x.png'),
            ],
            bottomTittle: '智慧工厂解决方案',
            bottomEn: 'Smart factory solutions',
            bottomDesc: '智慧工厂解决方案深度融合工业物联网与数字孪生技术，通过智能传感器与边缘网关实现温度、压力等30+参数毫秒级采集，兼容90%主流PLC设备。系统集成LSTM算法实现设备健康度分析（预警准确率98.6%），结合5G/光纤双通道构建OT/IT融合平台，驱动MES/ERP系统智能排程。工厂智慧园区采用全光网络架构，部署丰富的感知节点实现电力、安防等设施实时监控。',
            bottomImg: [
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_gc_sjcj.png'),
                    imgs: require('../../public/img/intelligentize/bgimg5-1.png'),
                    title: '工业物联网数据采集',
                    desc: '工业物联网数据采集系统采用智能传感器与边缘网关，实现毫秒级数据采集。兼容Modbus、OPC UA、MQTT等工业协议，覆盖90%主流PLC设备。边缘计算节点实现数据清洗与特征提取，通过5G/光纤双通道上云，构建可视化监控平台。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_gc_zhyq.png'),
                    imgs: require('../../public/img/intelligentize/bgimg5-2.png'),
                    title: '工厂智慧园区',
                    desc: '工厂智慧园区集成综合布线、安防监控、能耗管理等子系统，采用全光网络（PON）架构实现千兆级数据传输。部署智能楼宇自控系统，实时监测电力、给排水、消防等设施的运行状态。融合AI视频分析技术，实现周界入侵识别准确率99.5%、消防通道堵塞预警响应时间≤3秒。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_gc_spzd.png'),
                    imgs: require('../../public/img/intelligentize/bgimg5-3.png'),
                    title: '数字化水平诊断',
                    desc: '通过产线实测与系统穿透，精准识别设备孤岛、系统割裂等转型瓶颈，生成数字化成熟度雷达图及五级评定结果，助力120多家制造企业，形成覆盖诊断-规划-落地的全流程方案，为区域产业升级提供可复制的标杆样本。'
                },
                {
                    img: require('../../public/img/intelligentize/icon_szh_zhptyy_gc_zxgz.png'),
                    imgs: require('../../public/img/intelligentize/bgimg5-4.png'),
                    title: '数字化转型改造',
                    desc: '通过物联网、AI算法与工业互联网技术深度融合，实现生产全流程数据实时采集与智能分析，助力企业构建柔性化生产体系，推动研发设计、生产管控等关键环节的数字化升级。'
                },
            ]
        },
      ],
      caseMenuList: [
        {
            name: '智慧园区',
            en: 'Smart Park',
            icon: require('../../public/img/intelligentize/icon_szh_cgal_yq_nor@2x.png'),
            activeIcon: require('../../public/img/intelligentize/icon_szh_cgal_yq_pre@2x.png'),
            img: require('../../public/img/intelligentize/pic_szh_cgal_yq_bg.png')
        },
        {
            name: '智慧能源',
            en: 'Smart energy',
            icon: require('../../public/img/intelligentize/icon_szh_cgal_ny_nor@2x.png'),
            activeIcon: require('../../public/img/intelligentize/icon_szh_cgal_ny_pre@2x.png'),
            img: require('../../public/img/intelligentize/pic_szh_cgal_ny_bg.png')
        },
        {
            name: '智慧港口',
            en: 'Smart port',
            icon: require('../../public/img/intelligentize/icon_szh_cgal_gk_nor@2x.png'),
            activeIcon: require('../../public/img/intelligentize/icon_szh_cgal_gk_pre@2x.png'),
            img: require('../../public/img/intelligentize/pic_szh_cgal_gk_bg.jpg')
        },
        {
            name: '智慧矿山',
            en: 'Smart Mine',
            icon: require('../../public/img/intelligentize/icon_szh_cgal_ks_nor@2x.png'),
            activeIcon: require('../../public/img/intelligentize/icon_szh_cgal_ks_pre@2x.png'),
            img: require('../../public/img/intelligentize/pic_szh_cgal_ks_bg.png')
        },
        {
            name: '智慧工厂',
            en: 'Smart Factory',
            icon: require('../../public/img/intelligentize/icon_szh_cgal_gc_nor@2x.png'),
            activeIcon: require('../../public/img/intelligentize/icon_szh_cgal_gc_pre@2x.png'),
            img: require('../../public/img/intelligentize/pic_szh_cgal_gc_bg.png')
        },
      ],
      currentCase: 0,
      caseDetailList: [
        {
            name: '智慧园区',
            desc: '智慧园区是一个利用先进的科技和信息技术来优化管理和提升效率的城市或区域。它通过物联网、大数据、人工智能等技术手段，将各个设施、设备、人员等互联互通，实现智能化的管理和服务。',
            table: [
                {
                    name: '智能字防',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_yq_znzf@2x.png')
                },
                {
                    name: '智慧消防',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_yq_zhxf@2x.png')
                },
                {
                    name: '智慧通行',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_yq_zhtx@2x.png')
                },
                {
                    name: '智慧能源',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_yq_zhny@2x.png')
                },
                {
                    name: '智慧运维',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_yq_zhyw@2x.png')
                },
            ],
            scenList: [
                {
                    name: '太阳工业城项目',
                    img: require('../../public/img/intelligentize/image@2x.png')
                },
                {
                    name: '白云机场三期龙口小布项目',
                    img: require('../../public/img/intelligentize/image@2x (1).png')
                },
                {
                    name: '不连沟煤矿智慧园区平台',
                    img: require('../../public/img/intelligentize/image@2x (3).png')
                },
                {
                    name: '江门创智城智慧园区平台',
                    img: require('../../public/img/intelligentize/image@2x (2).png')
                },
            ]
        },
        {
            name: '智慧能源',
            desc: '利用先进的传感器、监测设备和通信技术来实时监测电力供应和需求情况。通过收集和分析大量的数据，智慧电网可以更准确地预测和管理电力需求，从而优化能源分配和供应。',
            table: [
                {
                    name: '智能综合运维平台',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_ny_ywpt@2x.png')
                },
                {
                    name: '安防平台',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_ny_afpt@2x.png')
                },
                {
                    name: '储能',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_ny_cn@2x.png')
                },
            ],
            scenList: [
                {
                    name: '地质监测预警平台',
                    img: require('../../public/img/intelligentize/image@2x (4).png')
                },
                {
                    name: '智能综合运维平台',
                    img: require('../../public/img/intelligentize/image@2x (5).png')
                },
                {
                    name: '光储充运营平台',
                    img: require('../../public/img/intelligentize/image@2x (6).png')
                },
                {
                    name: '智慧电力分布安防平台',
                    img: require('../../public/img/intelligentize/image@2x (7).png')
                },
            ]
        },
        {
            name: '智慧港口',
            desc: '创新技术和解决方案提升港口运营效率和服务质量的概念，通过智能物流系统、自动化设备、数据分析和预测等手段实现优化，为用户提供更快、更安全、更可靠的服务。',
            table: [
                {
                    name: '自动化控制PLC',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_gk_zdhkz@2x.png')
                },
                {
                    name: '三维可视化',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_gk_swkfh@2x.png')
                },
                {
                    name: '远程监控',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_gk_ycjk@2x.png')
                },
                {
                    name: '自动装车',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_gk_zdzc@2x.png')
                },
            ],
            scenList: [
                {
                    name: '港口可视化',
                    img: require('../../public/img/intelligentize/image@2x (10).png')
                },
                {
                    name: '远程监控系系统',
                    img: require('../../public/img/intelligentize/image@2x (9).png')
                },
                {
                    name: '自动化控制（PLC）系统',
                    img: require('../../public/img/intelligentize/image@2x (8).png')
                },
                {
                    name: '自动装车',
                    img: require('../../public/img/intelligentize/image@2x (11).png')
                },
            ]
        },
        {
            name: '智慧矿山',
            desc: '远程遥控、自动化采矿设备、无人机、虚拟现实和机器学习等，以提高矿山的效率、降低成本、减少事故等。智慧矿山还可以实现矿石的智能检测、运输优化、精细管理等功能，从而提高矿业企业的竞争力和可持续发展能力。',
            table: [
                {
                    name: '自动调度系统',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_ks_zddd@2x.png')
                },
                {
                    name: '疲劳驾驶监控',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_ks_pljs@2x.png')
                },
                {
                    name: '设备远程管理',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_ks_sbyc@2x.png')
                },
                {
                    name: '实时定位',
                    icon: require('../../public/img/intelligentize/icon_szh_cgal_ks_ssdw@2x.png')
                },
            ],
            scenList: [
                {
                    name: '边坡位移监测预警平台',
                    img: require('../../public/img/intelligentize/image@2x (12).png')
                },
                {
                    name: 'BIM建模',
                    img: require('../../public/img/intelligentize/image@2x (13).png')
                },
                {
                    name: '矿山场景漫游行走',
                    img: require('../../public/img/intelligentize/image@2x (14).png')
                },
                {
                    name: '矿井UWB厘米级人员定位',
                    img: require('../../public/img/intelligentize/image@2x (15).png')
                },
            ]
        },
        {
            name: '智慧工厂',
            desc: '应用信息技术、物联网、大数据分析等技术，实现智能化管理和自动化生产的工厂。智慧工厂通过数字化和智能化的手段，将生产设备、工序、物料等各个环节连接起来，实现生产过程的高效和智能化。',
            table: [
                {
                    name: '软件系统集成',
                    icon: require('../../public/img/intelligentize/1a (3).png')
                },
                {
                    name: '数据分析',
                    icon: require('../../public/img/intelligentize/1a (4).png')
                },
                {
                    name: '自动化',
                    icon: require('../../public/img/intelligentize/1a (5).png')
                },
                {
                    name: '物联网',
                    icon: require('../../public/img/intelligentize/1a (6).png')
                },
            ],
            scenList: [
                {
                    name: '数字工厂',
                    img: require('../../public/img/intelligentize/1a (7).png')
                },
                {
                    name: '安全生产',
                    img: require('../../public/img/intelligentize/1a (8).png')
                },
                {
                    name: '制造分析',
                    img: require('../../public/img/intelligentize/1a (1).png')
                },
                {
                    name: '能源管理',
                    img: require('../../public/img/intelligentize/1a (2).png')
                },
            ]
        }
      ],
      bigImg: [],
      bigImgIndex: 0,
      scrollIndex: 0, // 新增：当前最左侧显示的卡片索引
    };
  },
  computed: {
    platFormHeadCurrent() {
        return this.platFormDetails[this.platFormActive].topImg[this.head_ative]
    },
    currentCaseImg() {
        return this.caseMenuList[this.currentCase].img
    },
    containerWidth() {
      const total = this.platFormDetails[this.platFormActive].bottomImg.length;
      return Math.min(
        this.visibleCount * (this.cardWidth + this.cardGap) - this.cardGap,
        total * (this.cardWidth + this.cardGap) - this.cardGap
      );
    },
    maxOffset() {
      const total = this.platFormDetails[this.platFormActive].bottomImg.length;
      const totalWidth = total * (this.cardWidth + this.cardGap) - this.cardGap;
      return Math.min(0, this.containerWidth-200 - totalWidth);
    },
    rightWidth() {
      return this.containerWidth - 200  + 'px';
    },
  },
  created() {},
  mounted() {
    this.adjustHeightForScreenSize();
  },
  updated() {},

  methods: {
    adjustHeightForScreenSize() {
      const screenWidth = window.innerWidth;
      if (screenWidth < 1600) {
        // 如果屏幕宽度小于1600px，将所有platFormDetails的hig值加10px
        this.platFormDetails.forEach(item => {
          if (item.hig) {
            let numericValue;
            if (item.hig.includes('px')) {
              numericValue = parseInt(item.hig);
            } else if (item.hig === '0') {
              numericValue = 0;
            } else {
              numericValue = parseInt(item.hig);
            }
            item.hig = (numericValue + 40) + 'px';
          }
        });
      }
    },
    classObj(index) {
      if(this.platFormActive == 0 && index == this.platFormActive) {
       return 'platFormBg1' 
      }else if((this.platFormActive == 1 || this.platFormActive == 2 || this.platFormActive == 3) && index == this.platFormActive) {
       return 'platFormBg2' 
      }else if(this.platFormActive == 4 && index == this.platFormActive){
        return 'platFormBg3'
      } else {
        return ''
      }
    },
    bottomAtiveClick(index, type) {
      if (type === 'next') {
        if (this.bottom_ative < this.platFormDetails[index].bottomImg.length - 1) {
          this.bottom_ative++;
        }
      } else if (type === 'prev') {
        if (this.bottom_ative > 0) {
          this.bottom_ative--;
        }
      }
      this.$nextTick(() => {
        setTimeout(() => {
          let activeCard = this.$refs['activeCard-' + index + '-' + this.bottom_ative];
          if (Array.isArray(activeCard)) activeCard = activeCard[0];
          let rightEl = this.$refs['rightScroll' + index];
          if (Array.isArray(rightEl)) rightEl = rightEl[0];
          if (rightEl && rightEl.$el) rightEl = rightEl.$el;
          if (activeCard && rightEl) {
            if (typeof activeCard.scrollIntoView === 'function') {
              activeCard.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
            }
          }
          if (
            this.bottom_ative === this.platFormDetails[index].bottomImg.length - 1 &&
            rightEl &&
            typeof rightEl.scrollTo === 'function'
          ) {
            rightEl.scrollTo({ left: rightEl.scrollWidth - rightEl.clientWidth, behavior: 'smooth' });
          }
        }, 50);
      });
    },
    headAtiveClick(index, type) {
        if(type == 'next'){

            if(this.platFormDetails[index].topImg.length > this.head_ative + 1){
                this.head_ative++;
            }
        }
        if(type == 'prev'){
            if(this.head_ative > 0){
                this.head_ative--;
            } 
        }
    },
    bigImgClick(index, type) {
        if(type == 'next') {
            if(this.bigImg.length > index + 1) {
                this.bigImgIndex++;
            }
        }
        if(type == 'prev') {
            if(this.bigImgIndex > 0) {
                this.bigImgIndex--;
            }
        }
    },

    caseMenuClick(index) {
        this.currentCase = index;
    },
    showPic(index, inx) {
        this.showBigPic = true
        this.bigImg = this.caseDetailList[index].scenList
        this.bigImgIndex = inx;
    },
    clickNav(index) {
        this.platFormActive = index;
        this.head_ative = 0;
        this.bottom_ative = 0;
        this.offset = 0; 
    },
    closeTop() {
      this.isShow = false;
    },

  },
};
</script>

<style lang="scss" scoped>
// @import "~@/style/base.scss";
::v-deep .el-main{
    overflow: hidden;
}
.title {
    font-size: 40px;
    font-weight: bold;
    height: 48px;
    line-height: 48px;
    color: #333;
    font-family: "PingFang SC", "PingFang SC-400";
    text-align: center;
    &::after {
      content: "";
      display: block;
      width: 80px;
      height: 4px;
      background: linear-gradient(90deg,#0c9aff, #0c45ff 100%);;
      margin: 10px auto 0;
    }
  }
.bg-scheme{
    width: 1427px;
    height: 106px;
    font-size: 76px;
    font-family: "PingFang SC", "PingFang SC-400";
    font-weight: 400;
    text-align: center;
    margin: 0 auto;
    color: #fff;
    -webkit-text-fill-color: #fff; //文字填充色
    -webkit-text-stroke-width: 2px; //描边宽度
    -webkit-text-stroke-color: transparent; //描边颜色透明
    background: linear-gradient(to bottom, #000, #fff);
    -webkit-background-clip: text; //背景剪裁到文字;
    background-clip: text; //背景剪裁到文字;
    opacity: 0.3;
}
.ability {
    margin-top: 60px;
    .list{
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        gap: 20px;
        margin-top: -35px;
        .item{
            width: 330px;
            min-height: 300px;
            height: 100%;
            background: #fff; 
            border: 2px solid #e5e7eb;
            border-radius: 12px;
            z-index: 1;
            margin-left: 1%;
            .img{
                padding: 30px;
            }
            .name{
                height: 32px;
                font-size: 24px;
                font-family: "PingFang SC", "PingFang SC-400";
                font-weight: 400;
                text-align: center;
                color: #000000;
                line-height: 32px;
            }
            .desc{
                // display: inline-block;
                max-width: 233px!important;
                margin: 15px auto 0;
                height: 48px;
                font-size: 14px;
                font-family: "PingFang SC", "PingFang SC-400";
                font-weight: 400;
                text-align: center;
                color: #666666;
                // line-height: 24px;
                
            }
            .desc1{
                font-family: "PingFang SC", "PingFang SC-400";
                font-weight: 400;
                text-align: center;
                color: #666666;   
            }
            &:hover{
                border: 2px solid #0c45ff;
                // box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.4);
            }
        }
    }
}
// 五大服务
.service {
    background: #fafafa;
    width: 100%;
    height: 100%;
    padding: calc(60 * 100vw / 1920) 0;
    overflow: hidden;

    .wrapper {
        width: 100%;
        max-width: 1920px;
        margin: 0 auto;
        transform-origin: top center;
        transform: scale(calc(100vw / 1920));
        margin-bottom: 60px;

        @media screen and (min-width: 1920px) {
            transform: none;
        }
    }

    .list{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        width: 1410px;
        margin: 0 auto;
        margin-top: 30px;
        // margin-bottom: 200px;
        gap: 150px;
        position: relative;
        
       
        .item{
            width: 300px;
            height: 300px;
            background: #fff;
            border: 2px solid #e5e7eb;  
            border-radius: 12px;
            transform: rotate(45deg);
            &:nth-child(4){
                margin-top: -230px;
            }
            &:nth-child(5){
                margin-top: -230px;
            }
            .img, .name, .desc{
                transform: rotate(-45deg);
            }
            .img{
                margin-left: -80px;
                margin-top: 45px;
            }
            .name{ 
                font-size: 24px;
                font-family: "PingFang SC", "PingFang SC-400";
                font-weight: 400;
                text-align: center;
                color: #333333;
                margin-top: -10px;
                margin-left: 30px;
            }
            .desc{
                font-size: 14px;
                font-family: "PingFang SC", "PingFang SC-400";
                font-weight: 400;
                text-align: center;
                color: #666666;
                line-height: 24px;
                margin-top: -15px;
                margin-left: 90px;
                
            }
            &:hover{
                border: 2px solid #0c45ff;
                // box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.4);
            }
        }
    }

    .title {
        transform: scale(1);
        transform-origin: center center;
    }

    .bg-scheme {
        transform: scale(1);
        transform-origin: center center;
    }
}
// 智慧平台运营
.platform {
    position: relative;
    .wrapper {
        // margin-left: 200px;
        // height: 100px;
    }
    .list{
        width: 100%;
        max-width: 1000px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        // margin-top: -30px;
        // position: relative;
        // top: -60px;
        overflow-x: auto;
        scrollbar-width: thin;
        scrollbar-color: #ccc #f4f6f9;
        // height: 100px;
        &::-webkit-scrollbar {
          height: 8px;
        }
        &::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 4px;
        }
        &::-webkit-scrollbar-track {
          background: #f4f6f9;
        }
        .item{
            flex: 0 0 200px;
            width: 200px;
            height: 56px;
            line-height: 56px;
            z-index: 10;
            .box{
                 width: 200px;
                height: 56px;
                line-height: 56px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 24px;
                font-weight: 600;
                cursor: pointer;
            }
            .img{
                display: flex;
                align-items: center;
                margin-right: 8px;
            }
            .activeNav{
                color: #0C45FF;
                font-family: "PingFang SC", "PingFang SC-400";
                font-weight: 600;
            }
        }
        .platFormBg1{
            background: url('../../public/img/intelligentize/pic_szh_zhptyy_left_pre.png');
            background-size: cover; 
            background-position: center; 
            background-repeat: no-repeat; 
            width: 100%; 
            height: 100%; 
        }
       .platFormBg2{
            background: url('../../public/img/intelligentize/pic_szh_zhptyy_mid_pre.png');
            background-size: cover; 
            background-position: center; 
            background-repeat: no-repeat; 
            width: 100%; 
            height: 100%; 
        }
       .platFormBg3{
            background: url('../../public/img/intelligentize/pic_szh_zhptyy_right_pre.png');
            background-size: cover; 
            background-position: center; 
            background-repeat: no-repeat; 
            width: 100%; 
            height: 100%; 
        } 
    }
    .tab_bg{
            height: 858px;
            width: 100%;
            bottom: 0;
            left: 0;
        }
   .tab{
    position: relative;
    height: 450px;
    width: 100%;
    .carousel{
        display: flex;
        width: 100%;
        max-width: 1400px;
        height: 720px;
        justify-content: center;
        align-items: center;
        // margin-bottom: 50px;
        margin: 0 auto;
        padding-top: 50px;
        .toleft{
                    width: 40px;
                    height:40px;
                    margin-right: 20px;
                    background: url('../../public/img/intelligentize/icon_szh_zhptyy_lb_left_nor@2x.png');
                    background-size: 100% 100%;

                    background-position: center;
                    background-repeat: no-repeat;
                    &:hover{
                        background: url('../../public/img/intelligentize/icon_szh_zhptyy_lb_left_pre@2x.png'); 
                        background-size: 100% 100%;
                        background-position: center;
                        background-repeat: no-repeat;
                    }
                }
               .toright{
                    width: 40px;
                    height: 40px;
                    background: url('../../public/img/intelligentize/icon_szh_zhptyy_lb_right_nor@2x.png');
                    background-size: 100% 100%;
                    margin-left: 20px;
                    background-position: center;
                    background-repeat: no-repeat;
                    &:hover{
                        background: url('../../public/img/intelligentize/icon_szh_zhptyy_lb_right_pre@2x.png'); 
                        background-size: 100% 100%;
                        background-position: center;
                        background-repeat: no-repeat;
                    }
                } 
        .toleft, .toright {
            flex-shrink: 0;

        }
        .pic{
            border: 12px solid transparent;
            border-radius: 16px;
            background-clip: padding-box, border-box;
            background-origin: padding-box, border-box;
            background-image: linear-gradient(to right, #222, #222),linear-gradient(135deg, #00aaff, #0c45ff 26%, #00aaff 49%, #0c45ff 71%, #00aaff);
            img{
                width: 950px;
                // height: 500px;
                // object-fit: cover;
            }
        }
    }
    .bottom{
        display: flex;
        width: 100%;
        max-width: 1400px;
        margin: 0 auto;
        padding: 0 20px;
        margin-top: -50px;
        .left{
            width: 242px;
            .c_title{
                font-size: 40px;
                font-family: "PingFang SC", "PingFang SC-400";
                font-weight: 400;
                color: #ffffff;
                text-shadow: 0px 2px 3px 0px rgba(0,12,250,0.30); 
                text-align: left;
                width: 384px;
            }
            .en{
                margin-top: 4px;
                font-size: 12px;
                font-family: "PingFang SC", "PingFang SC-400";
                font-weight: 400;
                text-align: LEFT;
                color: #ffffff;
                opacity: 0.6;
                width: 328px;
            }
            .desc{
                width: 484px;
                margin-top: 16px;
                text-align: left;
                font-size: 14px;
                font-family: "PingFang SC", "PingFang SC-400";
                font-weight: 400;
                color: #ffffff;
                opacity: 0.9;
            }
            .btn{
                margin-top: 137px;
                display: flex;
                .toleft{
                    width: 40px;
                    height: 40px;
                    margin-right: 20px;
                    background: url('../../public/img/intelligentize/icon_szh_zhptyy_left_nor@2x.png');
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    &:hover{
                        background: url('../../public/img/intelligentize/icon_szh_zhptyy_left_pre@2x.png'); 
                        background-size: cover;
                        background-position: center;
                        background-repeat: no-repeat;
                    }
                }
               .toright{
                    width: 40px;
                    height: 40px;
                    background: url('../../public/img/intelligentize/icon_szh_zhptyy_right_nor@2x.png');
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    &:hover{
                        background: url('../../public/img/intelligentize/icon_szh_zhptyy_right_pre@2x.png'); 
                        background-size: cover;
                        background-position: center;
                        background-repeat: no-repeat;
                    }
                } 
            }
        }
        .right{
            width: 1400px;
            min-width: 0;
            overflow-x:auto ;
            position: relative;
            margin: 0 auto;
            // scrollbar-width: thin;
            scrollbar-color: #ccc #f4f6f9;
            &::-webkit-scrollbar {
              height: 8px;
            }
            &::-webkit-scrollbar-thumb {
              background: #ccc;
              border-radius: 4px;
            }
            &::-webkit-scrollbar-track {
              background: #f4f6f9;
            }
            .scroll-inner {
              display: flex;
              gap: 12px;
              transition: transform 0.3s;
            }
            .left-gap {
              width: 300px;
              flex-shrink: 0;
              pointer-events: none;
            }
            .label{
                box-sizing: border-box;
                margin: 0;
                padding: 0;
                flex-shrink: 0;
                position: relative;
                width: 322px;
                height: 420px;
                background: linear-gradient(180deg,rgba(6,0,173,0.50), rgba(6,0,173,0.00) 100%);
                border: 0.5px transparent;
                border-radius: 6px;
                background-clip: padding-box, border-box;
                background-origin: padding-box, border-box;
                background-image: transparent,linear-gradient(180deg, #ffffff, rgba(255,255,255,0.00) 100%);
                .bg{
                    position: absolute;
                    top: 33px;
                    width: 156px;
                    height: 156px;
                    right: 35px;
                    opacity: 0.2;
                    img{
                        width: 100%;
                    }
                }
                .l_img{
                    text-align: left;
                    width: 80px;
                    height: 80px;
                    margin-top: 47px;
                    margin-left: 24px;
                    img{
                        width: 100%;
                    }
                }
                .l_title{
                    margin-top: 9.75px;
                    font-size: 20px;
                    font-family: 'PingFang SC', "PingFang SC-400";
                    font-weight: 600;
                    color: #fff;
                    text-align: left;
                    margin-left: 24px;
                }
                .l_desc{
                    margin-top: 24px;
                    font-size: 14px;
                    color: #fff;
                    font-family: "PingFang SC", "PingFang SC-400";
                    font-weight: 400;
                    text-align: left;
                    width: 274px;
                    margin-left: 24px;
                    opacity: 0.8;
                }
            }
            .bottom_label_active{
                background: linear-gradient(180deg,rgba(255,255,255,0.70), #ffffff 100%);
                .l_title{
                    color: #0C45FF;
                }
                .l_desc{
                    color: #333333;
                }
            }
        }
    }
   }
} 
.right.scrollable {
  width: 1100px !important;
  overflow-x: auto !important;
  position: relative;
  right: -300px;
  margin: 0 auto;
  background: transparent;
    scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;
}
.right::-webkit-scrollbar {
  display: none !important; /* Webkit 隐藏 */
}

// 数字化转型
.digital {
    width: 100%;
    height: 100%;
    padding: 60px 0 60px 0;
    background: url('../../public/img/intelligentize/pic_azh_szhzx_bg.png');
    background-size: cover; 
    background-position: center; 
    background-repeat: no-repeat; 
    .box{
        position: relative;
        display: flex;
        justify-content: space-around;
        width: 1410px;
        margin: 0 auto;
        margin-top: -35px;
        z-index: 10;
        .img{
            margin-top: 40px;
        }
        .text1{
            color: transparent;
            background-image: linear-gradient(90deg,#0c9aff, #0c45ff 100%);
            background-clip: text;
            -webkit-background-clip: text;
            display: inline-block;
            font-size: 24px;
            font-family: "PingFang SC", "PingFang SC-400";
            font-weight: 600;
        }
        .text2{
            font-size: 24px;
            font-family: "PingFang SC", "PingFang SC-400";
            font-weight: 600;
            color: #333;
        }
    }  
}
// 成功案例
.case {
    margin-top: 80px;
    padding-bottom: 60px;
  .box{
    position: relative;
    width: 1400px;
    height: 700px;
    margin: 0 auto;
    margin-top: -30px;
    .img{
        position: relative;
        width: 1400px;
        height: 700px;
    }
    .footIcon{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 128px;
        height: 128px;
    }
    .framework{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 1400px;
        height: 700px;
        .filter{
            position: absolute;
            left: 0;
            bottom: 0;
            width: 1068px;
            height: 190px;
            background: rgba(255,255,255,0.01);
            backdrop-filter: blur(10px);
        }
        .wrap{
            display: flex;
            justify-content: space-between;
            width: 1400px;
            height: 700px;
            .left{
                margin-top: 300px;
                .item{
                    width: 100%;
                    // height: 100%;
                    margin-left: 60px;
                    .i_name{
                        font-size: 40px;
                        font-family: "PingFang SC", "PingFang SC-400";
                        font-weight: 400;
                        text-align: LEFT;
                        color: #ffffff;
                    }
                    .i_desc{
                        margin-top: 12px;
                        width: 700px;
                        font-size: 14px;
                        font-family: "PingFang SC", "PingFang SC-400";
                        font-weight: 400;
                        text-align: LEFT;
                        color: #ffffff;
                    }
                    .ul{
                        margin-top: 24px;
                        display: flex;
                        gap: 16px;
                    }
                    .label{
                        display: flex;
                        align-items: center;
                        .l_img{
                            width: 46px;
                            height: 46px;
                            
                            img{
                                width: 100%;
                            }
                        }
                        .l_name{
                            margin-left: -20px;
                            font-size: 14px;
                            padding: 8px 16px 8px 35px;
                            font-family: "PingFang SC", "PingFang SC-400";
                            font-weight: 400;
                            text-align: LEFT;
                            color: #ffffff;
                            // background: linear-gradient(90deg,rgba(16,29,72,0.00), rgba(16,29,72,0.40) 100%);
                            // border: 1px solid;
                            // border-image: linear-gradient(90deg, rgba(255,255,255,0.00) 0%, rgba(255,255,255,0.60) 100%) 1 1;
                            // border-radius: 19px;
                            border: 1px solid transparent;
                            border-radius: 19px;
                            background-clip: padding-box, border-box;
                            background-origin: padding-box, border-box;
                            background-image: linear-gradient(90deg,rgba(16,29,72,0.00), rgba(16,29,72,0.40) 100%), linear-gradient(90deg, rgba(255,255,255,0.00) 0%, rgba(255,255,255,0.60) 100%);
                        }
                    }
                    .scene{
                        position: relative;
                        margin-left: -60px;
                        display: flex;
                        .scene_l{
                            margin-top: 90px;
                            margin-left: 60px;
                            z-index: 10;
                            .name{
                                width: 96px;
                                height: 34px;
                                font-size: 24px;
                                font-family: "PingFang SC", "PingFang SC-400";
                                font-weight: 400;
                                text-align: left;
                                color: #ffffff;
                            }
                            .en{
                                margin-top: 4px;
                                width: 96px;
                                height: 34px;
                                font-size: 12px;
                                font-family: "PingFang SC", "PingFang SC-400";
                                font-weight: 400;
                                text-align: left;
                                color: #ffffff;
                                opacity: 0.6;
                            }
                        }
                        .scene_r{
                            margin-left: 40px;
                            display: flex;
                            gap: 16px;
                            .pic{
                                margin-top: 73px;
                                .img{
                                    width: 196px;
                                    height: 110px;
                                    position: relative;
                                    img{
                                        width: 100%;
                                    }
                                }
                                .name{
                                    position: absolute;
                                    bottom: 0px;
                                    width: 196px;
                                    height: 50px;
                                    font-size: 12px;
                                    font-family: "PingFang SC", "PingFang SC-400";
                                    font-weight: 400;
                                    text-align: center;
                                    color: #ffffff;
                                    background: linear-gradient(180deg,rgba(8,24,72,0.00), #081848 100%);
                                    border-radius: 0px 0px 4px 4px;
                                    line-height: 50px;
                                    
                                }
                            }
                        }
                    }
                }
            }
            .right{
                .list{
                    .currentBg{
                        background: url('../../public/img/intelligentize/pic_szh_cgal_bql_pre.png');
                        background-size: 100% 100%;
                    }
                    .item{
                        width: 330px;
                        height: 140px;
                        display: flex;
                        align-items: center;
                        position: relative;
                        cursor: pointer;
                        &::after{
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            content: '';
                            width: 330px;
                            border-bottom: 0.5px solid transparent;
                            background-clip: padding-box, border-box;
                            background-origin: padding-box, border-box;
                            background-image: linear-gradient(90deg,rgba(16,29,72,0.00), rgba(16,29,72,0.40) 100%), linear-gradient(90deg, rgba(255,255,255,0.00) 0%, rgba(255,255,255,0.60) 100%);
                        }
                        .icon{
                            margin-left: 134px;
                            width: 42px;
                            height: 48px;
                            img{
                                width: 100%;
                            }
                        }
                        .msg{
                            margin-left: 28px;
                            .m_name{
                                font-size: 24px;
                                font-family: "PingFang SC", "PingFang SC-400";
                                font-weight: 400;
                                text-align: LEFT;
                                color: #ffffff;
                                opacity: 0.6;
                            }
                            .currentName{
                                opacity: 1;
                            }
                            .m_en{
                                font-size: 14px;
                                font-family: "PingFang SC", "PingFang SC-400";
                                font-weight: 400;
                                text-align: LEFT;
                                color: #ffffff;
                                opacity: 0.6;
                            }
                            .currentEn{
                              opacity: 1;
                            }
                        }
                    }
                }
            }
        }
    }
}
}
.mask{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
        justify-content: center;
        align-items: center;
    .dialog{
        background: #081848;
        width: 600px;
        height: 393px;
        margin: 0 auto;
        border-radius: 15px;
        
        .head{
            padding: 14px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .left{
                display: flex;
                .icon{
                    width: 24px;
                    height: 24px;
                    img{
                        width: 100%;
                    }
                }
                .name{
                    color: #fff;
                    font-size: 16px;
                    font-family: "PingFang SC", "PingFang SC-400";
                    font-weight: 400;
                }
            }
            .close{
                width: 24px;
                height: 24px;
                cursor: pointer;
                img{
                    width: 100%;
                }
            }
        }
        .bigImg{
            width: 592px;
            height: 333px;
            margin: 0 auto;
            position: relative;
            display: inline-block;
            &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: linear-gradient(
                    90deg, 
                    #081848 0px,
                    rgba(255,255,255,0) 40px,
                    rgba(255,255,255,0) calc(100% - 40px),
                    #081848 100%
                );
                pointer-events: none;
            }
            img{
                width: 100%;
            }
        }
        .btn{
            position: relative;
            margin-top: -190px;
            padding: 0 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            z-index: 10;
            .pre{
                    width: 40px;
                    height: 40px;
                    margin-right: 10px;
                    background: url('../../public/img/intelligentize/icon_szh_zhptyy_left_pre@2x.png');
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    background: url('../../public/img/intelligentize/icon_szh_zhptyy_left_pre@2x.png'); 
                        background-size: cover;
                        background-position: center;
                        background-repeat: no-repeat;
                    }
           
                }
               .next{
                    width: 40px;
                    height: 40px;
                    background: url('../../public/img/intelligentize/icon_szh_zhptyy_right_pre@2x.png');
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    &:hover{
                        background: url('../../public/img/intelligentize/icon_szh_zhptyy_right_pre@2x.png'); 
                        background-size: cover;
                        background-position: center;
                        background-repeat: no-repeat;
                    }
                }
        }
    }


.yuan1{
    width: 418px;
    height: 418px;
}
.boxsimg{
    width: 1400px;
    height: 700px;
}
.footimg{
    width: 128px;
    height: 128px;
}
.listimgs{
    width: 120px;
    height: 120px;
}
.serviceimg{
    width: 110px;
    height: 111px;
    object-fit: cover;
}
</style>
